exports.branchAddress = (value) => {
    switch (value) {
        case 'qurdiani':
            return "დიდუბე";
            break
        case 'didube':
            return "დიდუბე";
            break
        case 'gldani':
            return "გლდანი";
            break
        case 'isani':
            return "ისანი";
            break
        case 'kutaisi_1':
            return "ქუთაისი";
            break
        case 'digomi':
            return "დიდი დიღომი";
            break
        default:
            return value
    }
}
